import { useEffect } from 'react'
import React from 'react'
import PublicLayout from '@/pages/PublicLayout'
import Simple from '@/components/layouts/AuthLayout/Simple'
import SignUp from '@/components/pages/auth/SignUp/SignUp'
import { Head, router, usePage } from '@inertiajs/react'
import { trackEvent } from '@/api/analytics/trackEvent'

const SignUpPage = () => {
    const { registrationEnabled } = usePage<{ registrationEnabled: boolean }>().props

    useEffect(() => {
        if (!registrationEnabled) {
            router.visit('/subscribe')
        }
    }, [registrationEnabled])

    useEffect(() => {
        trackEvent({ event_type: 'registration.view' });
    }, []);

    if (!registrationEnabled) {
        return null
    }

    return (
        <>
            <Head>
                <title>Create Account</title>
                <meta name="description" content="Create a free MemoSlate account and start storing your encrypted, privacy-focused notes today." />
            </Head>
            <Simple>
                <SignUp />
            </Simple>
        </>
    )
}

SignUpPage.layout = (page: React.ReactNode) => <PublicLayout children={page} />
export default SignUpPage
